import React from "react";
import PropTypes from "prop-types";
import { CardGiftcardOutlined as GiftCardIcon } from "@mui/icons-material";
import { NoData } from "../../../../Components/ui";

const GiftCardsEmptyState = ({
  hasActiveFilters = false,
  onResetFilters,
}) => {
  return (
    <NoData
      icon={<GiftCardIcon sx={{ fontSize: 32 }} />}
      title={
        hasActiveFilters
          ? "No Matching Gift Cards Found"
          : "No Active Gift Cards"
      }
      subtitle={
        hasActiveFilters
          ? "We couldn't find any gift cards matching your selected search query or category filter. Try broadening your keywords."
          : "There are currently no active digital gift cards or giveaway vouchers available on-chain. Check back shortly for new promotional drops."
      }
      actionText={hasActiveFilters ? "Reset All Filters" : undefined}
      onAction={hasActiveFilters ? onResetFilters : undefined}
      minHeight={340}
    />
  );
};

GiftCardsEmptyState.propTypes = {
  hasActiveFilters: PropTypes.bool,
  onResetFilters: PropTypes.func,
};

export default GiftCardsEmptyState;
